import Spinner, { SpinnerSize } from "@galaxy-io/dls/feedback/Spinner";
import Flex, { AlignItems, FlexDirection, JustifyContent } from "@galaxy-io/dls/layout/Flex";
import Text, { TextSize, TextVariant } from "@galaxy-io/dls/text/Text";

/** Unknown-shape loads stay inside their region and honor reduced motion. */
export function LoadingLayout({ message = "Loading…" }: { message?: string }) {
  return (
    <div role="status" aria-live="polite" aria-busy="true">
      <Flex
        fillWidth
        grow={1}
        direction={FlexDirection.COLUMN}
        alignItems={AlignItems.CENTER}
        justifyContent={JustifyContent.CENTER}
        gap={8}
        padding={[48, 24]}
      >
        <Spinner size={SpinnerSize.MEDIUM} ariaLabel={message} />
        <Text size={TextSize.BODY_SM} variant={TextVariant.SECONDARY}>
          {message}
        </Text>
      </Flex>
    </div>
  );
}
